import React from "react";
import "../assets/css/anh-duong-talent.css";
import TalentHeroSection from "./TalentHeroSection";
import { TalentOverviewSection, TalentMissionSection, TalentEcosystemSection } from "./TalentFoundationSections";
import { SolarCompetencySection, TalentProgramsSection, TalentCourseCatalogSection, TalentRoadmapSection } from "./TalentProgramsSections";
import { TalentNetworkSection, TalentExpertsSection, TalentAudienceSection } from "./TalentCommunitySections";
import { TalentBenefitsSection, TalentFaqSection, TalentCtaSection } from "./TalentSupportSections";

const AnhDuongTalentPage = () => (
  <main className="anh-duong-talent-page">
    <TalentHeroSection />
    <TalentOverviewSection />
    <TalentMissionSection />
    <TalentEcosystemSection />
    <SolarCompetencySection />
    <TalentProgramsSection />
    <TalentCourseCatalogSection />
    <TalentRoadmapSection />
    <TalentNetworkSection />
    <TalentExpertsSection />
    <TalentAudienceSection />
    <TalentBenefitsSection />
    <TalentFaqSection />
    <TalentCtaSection />
  </main>
);

export default AnhDuongTalentPage;
